<template>
  <section id="comparar" class="compare-section">
    <div class="container">
      <div class="section-header text-center mb-4">
        <h2 class="section-title">Más barato y con más beneficios</h2>
        <p class="section-subtitle">
          Comparado con los precios publicados de otra membresía en el Metroplex (octubre 2026).
        </p>
      </div>
      <div class="tbl-wrap">
        <table>
          <thead>
            <tr>
              <th>Concepto</th>
              <th>Hispano Medical Plan</th>
              <th>Otro plan del mercado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, i) in rows" :key="i">
              <td>{{ row[0] }}</td>
              <td class="us">{{ row[1] }}</td>
              <td class="them">{{ row[2] }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
import { COMPARE_MARKET_ROWS } from '../data/hmpPlans2027'

/**
 * Tabla comparar Hispano Medical Plan vs mercado (mockup 2027).
 */
export default {
  name: 'CompareMarketSection',
  data() {
    return {
      rows: COMPARE_MARKET_ROWS
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/variables';

.compare-section {
  padding: 80px 0;
  background: $landing-bg-white;
}

.section-title {
  font-size: clamp(1.75rem, 3vw, 2.5rem);
  font-weight: 800;
  color: $landing-primary-color;
  margin-bottom: 0.5rem;
}

.section-subtitle {
  color: $landing-text-medium;
  font-size: 1.05rem;
  margin: 0;
}

.tbl-wrap {
  overflow-x: auto;
  border: 1px solid $landing-border-light;
  border-radius: 18px;
  background: #fff;
}

table {
  width: 100%;
  border-collapse: collapse;
  min-width: 640px;
}

th,
td {
  padding: 14px 18px;
  text-align: left;
  border-bottom: 1px solid $landing-border-light;
  font-size: 0.98rem;
}

th {
  background: $landing-bg-light;
  color: $landing-primary-color;
  font-weight: 700;
}

tbody tr:last-child td {
  border-bottom: 0;
}

.us {
  color: $landing-teal;
  font-weight: 700;
}

.them {
  color: $landing-text-medium;
}

@media (max-width: 760px) {
  .compare-section {
    padding: 48px 0;
  }
}
</style>
